// extracted by mini-css-extract-plugin
export default {"alfa":"SensorType_alfa__oOW8e","btadd":"SensorType_btadd__VcLE7","creer":"SensorType_creer__Ucr9N"};